<template>
    <div class="favorite-projects" v-if="pageSetup != null">
        <div class="empty-msg-container" v-if="empty">
            <h2>{{ pageSetup.empty_favorite_complexes.msg }}</h2>
            <div class="instructions">
                <h3>{{ pageSetup.empty_favorite_complexes.info.title }}</h3>
                <ul>
                    <li v-for="(item, index) in pageSetup.empty_favorite_complexes.info.steps">
                        <span class="num">{{ index + 1}}</span>
                        <p v-if="index != 1" v-html="item.desc"></p>
                        <p v-else>
                            <span>{{ getCorrectStr(item.desc, 1) }}</span>
                            <svgIcon name="star-sales" class="icon-star"/>
                            <span> {{ getCorrectStr(item.desc, 2) }}</span>
                        </p>
                    </li>
                </ul>
            </div>
        </div>
        <!-- {{projectItems}} -->
        <salesFilter></salesFilter>
        <salesItems v-if="!isMobileChecker"></salesItems>
        <salesItemsMobile v-else></salesItemsMobile>
    </div>
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import salesItems from '@/components/sales/sale-item-new.vue'
    import salesFilter from '@/components/sales-filter/sales-filter.vue'
    import salesItemsMobile from '@/components/sales/sale-item-mobile.vue'
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    export default {
        name: 'favorite-projects',
        components: {
            salesItems,
            salesFilter,
            salesItemsMobile,
            svgIcon,
        },
        data () {
            return {
                empty: false,
                title: 'Жилые комплексы',
            }
        },
        computed: mapGetters({
            projectItems: 'loadProjectItems',
            pageSetup: 'loadFavoritePage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            checkForEmpty() {
                // Счетчик избранных карточек из LocalStorage
                var items = localStorage.getItem('favorite_projects');
                items = items ? items.split(',') : [];
                if (items.length == 0) {
                    this.empty = true;
                } else {
                    this.empty = false;
                }
                // console.log(items.length);
            },
            getCorrectStr(str, index) {
                var clearStr;
                if (index == 1) {
                    clearStr = str.split("<span>")[0];
                    return clearStr;
                } else {
                    clearStr = str.split("<span>")[1].replace('</span>', '');
                    return clearStr;   
                }
            }
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.projectItems != null) {
                next(vm => {
                    vm.checkForEmpty();
                    vm.$store.commit('removePageLoaderImg');
                    setTimeout(() => {
                        vm.$parent.$parent.$refs.topProgress.done();
                    }, 300);
                });
            } else {
                store.dispatch('getProjectsItems').then((response) => {
                    // console.log(resp, 'HOME')
                    if (response) {
                        next(vm => {
                            vm.checkForEmpty();
                            vm.$store.commit('removePageLoaderImg');
                            setTimeout(() => {
                                vm.$parent.$parent.$refs.topProgress.done();
                            }, 300);
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getProjectsItems');
        },
        created () {
            this.checkForEmpty();
            // this.$store.commit('setCustomCrumb', this.title);
        },
        mounted() {
            this.$store.watch(
                (state) => state.favoriteCount,
                (oldValue, newValue) => {
                    this.checkForEmpty();
                    // console.log('update')
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/favorite/favorite-projects.scss';
</style>